import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { Message, SpinnerService } from 'shared-components';
import { Router } from '@angular/router';

@Component({
    selector: 'app-central-avisos',
    templateUrl: './central-avisos.component.html'
})
export class CentralAvisosComponent implements OnInit {

    public mensajes = new Array<Message>();

    public toCloseSpinner = 0;

    public filterA = false;
    public filterM = false;
    public filterB = false;
    public filterD = false;
    public filterE = false;
    public filterC = false;

    public priority;

    public gridModal = false;
    public tituloGrid;

    public disabled = false;

    public addFilters = false;

    public dataExpedicionCero;

    public donutsEtiquetadores;
    public donutsDesignaciones;
    public donutsCultivos;

    public startAnimation = false;

    public _disableFilters: boolean;
    public numTotalAvisos: number;
    public numAvisos: number = 0;

    constructor(
        private readonly _router: Router,
        private readonly _dataService: DataService,
        private readonly _spinnerService: SpinnerService
    ) { }

    ngOnInit() {
        this.mensajes = [];
        this.mensajes.push({ class: 'success', message: 'central-avisos.filters.tipoAvisos' });
    }

    // ngAfterViewInit() {
    //   setTimeout (()=> this._disableFilters = false );
    // }

    public filterPriority(tipo: string) {
        if (tipo === 'A' && !this.filterA) {
            this.startAnimation = true;
            this.addFilters = true;
            this.filterA = true;
            this.filterB = false;
            this.filterM = false;
            this.disabled = true;
            setTimeout(() => {
                this.priority = 'ALTA';
                this.startAnimation = false;
                this.disabled = false;
            }, 450);
        } else if (tipo === 'M' && !this.filterM) {
            this.startAnimation = true;
            this.addFilters = true;
            this.filterA = false;
            this.filterB = false;
            this.filterM = true;
            this.disabled = true;
            setTimeout(() => {
                this.priority = 'MEDIA';
                this.startAnimation = false;
                this.disabled = false;
            }, 450);
        } else if (tipo === 'B' && !this.filterB) {
            this.startAnimation = true;
            this.addFilters = true;
            this.filterA = false;
            this.filterB = true;
            this.filterM = false;
            this.disabled = true;
            setTimeout(() => {
                this.priority = 'BAJA';
                this.startAnimation = false;
                this.disabled = false;
            }, 450);
        }
    }


    public filterTipo(tipo: string) {
        switch (tipo) {
            case 'E':
                this.filterE = true;
                this.filterD = false;
                this.filterC = false;
                this.priority = '';
                this.addFilters = false;
                this.filterA = false;
                this.filterB = false;
                this.filterM = false;
                break;
            case 'D':
                this.filterE = false;
                this.filterD = true;
                this.filterC = false;
                this.priority = '';
                this.addFilters = false;
                this.filterA = false;
                this.filterB = false;
                this.filterM = false;
                break;
            case 'H':
                this.filterE = false;
                this.filterD = false;
                this.filterC = true;
                this.priority = '';
                this.addFilters = false;
                this.filterA = false;
                this.filterB = false;
                this.filterM = false;
                break;
        }
    }

    public showAll() {
        if (this.addFilters) {
            this.startAnimation = true;
            this.addFilters = false;
            this.filterA = false;
            this.filterB = false;
            this.filterM = false;
            this.disabled = true;
            setTimeout(() => {
                this.priority = '';
                this.startAnimation = false;
                this.disabled = false;
            }, 450);
        }
    }

    public getDonutsEtiquetadores($event) {
        this.donutsEtiquetadores = $event;
    }

    public getDonutsDesignaciones($event) {
        this.donutsDesignaciones = $event;
    }

    public getDonutsCultivos($event) {
        this.donutsCultivos = $event;
    }

    public disableFilters($event){
      setTimeout (()=> this._disableFilters = $event );
      if(!$event) this.numTotalAvisos = 0;
      this.numAvisos = 0;
    }

    public getNumAvisosTotales(n: number){
      this.numTotalAvisos = n;
    }

    public getNumAvisos(n: number){
      this.numAvisos += n;
    }

    private checkCloseSpinner() {
      this.toCloseSpinner -= 1;
      if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
      }
    }

    public openDocHelp() {
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      this._dataService.getDocHelp('Data_Insigths_Warnings_Hub.pdf').toPromise().finally(() => {
          this.checkCloseSpinner();
      }).then((resp) => {
          localStorage.setItem('base64', resp.base64Archivo);
          const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
          window.open(url, '_blank');
      });
    }
}
